import { BgPremiumFooter1,BgPremiumFooter2,LogoIconWhite } from "constants/images";
import { FaArrowRightLong } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import Button from "components/button/button";
import { motion,AnimatePresence  } from "motion/react";
import React, { useState } from "react";
import { SubscriptionContext } from "context/subscription";
import PremiumModal from "./pop-up-premium";
import { useDialogHook } from "utils/customhooks";
import { useWindowDimensions } from "utils/customhooks";
import { useHistory } from "react-router-dom";

const FooterPremium = ({shshowSecondPremow, isFromLandingPage = false})=>{
    const [showPem,setShowPrem] = useState(true);
    const modalPremiumSub = useDialogHook(PremiumModal);
    const {localstorage } = global.services;
    const history = useHistory();
    const { setPremiumFooter } = React.useContext(SubscriptionContext);

    React.useEffect(() => {
    const hideUntil = localStorage.getItem('premium-footer-hide-until');

        if (hideUntil && Date.now() < Number(hideUntil)) {
            setShowPrem(false);
        }
    }, []);

    const onClickHandler = ()=>{
        const stored = localstorage.get("user_data");
        let user_data = stored && stored.value
            ? JSON.parse(stored.value)
            : {};
        if (!user_data?.profiles) {
            history.push("/sign-up");
            return;
        };
        setShowPrem(false)
        modalPremiumSub({},(callBack)=>{
            setShowPrem(true)
        })
    }

    const closeHandler = ()=>{
        const hideUntil = Date.now() + 86400000; // 24 hours
        localStorage.setItem('premium-footer-hide-until', hideUntil);
        if(isFromLandingPage){
            setShowPrem(false);
        }
        setPremiumFooter(false); localStorage.setItem('premium-footer', JSON.stringify(false))
    }

    return (
        <div>
            {
                showPem ? 
                <AnimatePresence mode="wait">
                        {
                            shshowSecondPremow &&
                            (<motion.div
                                initial={{ y: 50, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                exit={{  y: -50, opacity: 0 }}
                                transition={{ duration: 1, ease: "easeInOut" }}
                                className="px-2"
                            >
                                <div >
                                    <FooterPremium2 onClickHandler={onClickHandler} closeHandler={closeHandler}/>
                                </div>
                            </motion.div>)
                        }
                </AnimatePresence>
                :
                <></>
            }
        </div>
    )
}

const FooterPremium1 = ({showSecondPrem})=>{
    return (
        <div className={`text-white w-full`}
                style={{ backgroundImage: `url(${BgPremiumFooter1})`,
                backgroundSize:'cover',
                backgroundPosition:'center center',
                backgroundRepeat: 'no-repeat'
                }}
        >
        <div className="flex justify-between items-center py-4 px-2">
            <div className="flex gap-2">
                <img src={LogoIconWhite} alt="fIcon" className="w-12 h-12"/>
                <div>
                    <p className="text-sm">Show the word your achievements.</p>
                    <p className="text-sm font-bold">Create your Milestone Profile.</p>
                </div>
            </div>
            <div className="rounded-3xl bg-white cursor-pointer py-2 px-4 flex items-center justify-center text-primary text-sm" onClick={showSecondPrem}>
                <FaArrowRightLong />
            </div>
        </div>
        </div>
    )
}


const FooterPremium2 = ({onClickHandler,closeHandler})=>{
    const { isMobile } = useWindowDimensions();
    
    return (
        isMobile ? 
        <div className={`text-white w-full rounded-t-md relative`}
                style={{ backgroundImage: `url(${BgPremiumFooter2})`,
                backgroundSize:'cover',
                backgroundPosition:'center center',
                backgroundRepeat: 'no-repeat'
                }}
        >
        <div className="rounded-full bg-[#333333] cursor-pointer flex items-center justify-center text-white text-sm absolute z-100 right-1 top-2 p-1"
            onClick={closeHandler}
        >
            <MdClose />
        </div>
        <div className="flex pb-4 justify-center gap-2 pt-7">
            <img src={LogoIconWhite} alt="fIcon" className="w-12 h-12"/>
            <div className="flex gap-2 flex-col justify-center">
                <div>
                    <p className="text-sm">Show the word your achievements.</p>
                    <p className="text-sm font-bold">Create your Milestone Profile.</p>
                </div>
                <div className="w-3xl"> 
                        <Button
                            buttonName="Get Lifetime Access $67*"
                            buttonClass="group bg-white hover:bg-[#0b58a7] px-2 py-2"
                            buttonTextClass="flex items-center justify-center gap-2 text-primary group-hover:text-white text-sm font-semibold"
                            iconPosition="left"
                            onClick={onClickHandler}
                        /> 
                </div>
                <p className="text-xs ml-10">
                    * Limited time only
                </p>
            </div>
        </div>
        </div>
        :
        <div className="w-full flex justify-center">
            <div className={`text-white w-[64rem] rounded-t-md relative`}
                style={{ backgroundImage: `url(${BgPremiumFooter2})`,
                backgroundSize:'cover',
                backgroundPosition:'center center',
                backgroundRepeat: 'no-repeat'
                }}
            >
            <div className="rounded-full bg-[#333333] cursor-pointer flex items-center justify-center text-white text-sm absolute z-100 right-1 top-2 p-1"
                onClick={closeHandler}
            >
                <MdClose />
            </div>
            <div className="pb-4 gap-2 pt-7">
                <div className="flex gap-2 justify-between items-center m-4">
                    <div className="flex gap-2 items-center">
                        <img src={LogoIconWhite} alt="fIcon" className="w-16 h-16"/>
                        <div>
                            <p className="text-base">Show the word your achievements.</p>
                            <p className="text-base font-bold">Create your Milestone Profile.</p>
                        </div>
                    </div>
                    <div>
                        <div className="w-3xl"> 
                            <Button
                                buttonName="Get Lifetime Access $67*"
                                buttonClass="group bg-white hover:bg-[#0b58a7] px-2 py-2"
                                buttonTextClass="flex items-center justify-center gap-2 text-primary group-hover:text-white text-sm font-semibold"
                                iconPosition="left"
                                onClick={onClickHandler}
                            /> 
                        </div>
                        <p className="text-xs ml-10 mt-2">
                            * Limited time only
                        </p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}



export default FooterPremium;